import { useState, useEffect, useRef } from "react";
import axios from "axios";
import TablaMRT from "../../features/table/RTable";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import DescargarG from "../../assets/img/svg/users/descargarGreen.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import { useNavigate } from "react-router-dom";
import "./InstallersDocuments.css";
import CustomSelect from "../../ui/select/Select";
import Vigente from "../../assets/img/svg/providers/vigente.svg";
import PorExpirar from "../../assets/img/svg/providers/porExpirar.svg";
import Expirado from "../../assets/img/svg/providers/expirado.svg";
import No from "../../assets/img/svg/providers/no.svg";
import SideMenu from "../../features/sideMenu/SideMenu";
import Documento from "../../assets/img/svg/providers/documento.svg";
import Card from "../../features/cards/CardsGraph";
import VigenteGra from "../../assets/img/svg/providers/vigenteGra.svg";
import PorExpirarGra from "../../assets/img/svg/providers/porExpirarGra.svg";
import ExpiradoGra from "../../assets/img/svg/providers/expiradoGra.svg";
import NoGra from "../../assets/img/svg/providers/noGra.svg";
import PDFInstallers from "./PDFInstallers";
import CustomButton from "../../ui/button/Button";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import {
  formatEmpresa,
  capitalize,
  highlightText,
} from "../../utils/functionsFormat";
import {
  headCellCenterAlign,
  bodyCellCenterAlign,
  headCellLeftAlign,
} from "../../utils/columnStyles";
import { confirmarDescargarExcel } from "../functions/Functions";
import { exportarExcelInstaladores } from "../../utils/exportHelpers";
import {
  customStringFilter,
  customStatusFilter,
} from "../../features/table/filterFunctions";
import "./InstallersDocumentsPage.responsive.css";
import { ClickAwayListener, Popper } from "@mui/material";
import { itemsProviders } from "../../constants/providers";

const InstallersDocumentsPage = ({ API_URL }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState({ top: 0, left: 0 }); // Estado para el menú desplegable
  const [filtroSeleccionado, setFiltroSeleccionado] = useState("INE");
  const [estadoContratoFiltro, setEstadoContratoFiltro] = useState("Todos");
  const [tableInstance, setTableInstance] = useState(null);

  const calculateProgress = (status) => {
    const total = countByStatus("Todos");
    if (total === 0) return 0;

    const count = countByStatus(status);
    return Math.round((count / total) * 100);
  };

  const editarInstalador = async (id) => {
    navigate(`/proveedores/instaladores/editar/${id}`);
  };

  const documentosInstalador = async (id) => {
    navigate(`/proveedores/instaladores/documentos/${id}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `${API_URL}/api/info-docs-contactos-instaladores`,
        { withCredentials: true }
      );

      const sortedData = response.data.map((item) => {
        const contrato = item.empresa?.contrato;
        let estado = "NO_EXISTENTE";

        if (contrato?.fechaVencimiento) {
          const fechaVenc = new Date(contrato.fechaVencimiento);
          const hoy = new Date();
          const diff = Math.floor((fechaVenc - hoy) / (1000 * 60 * 60 * 24));
          if (diff < 0) estado = "EXPIRADO";
          else if (diff <= 60) estado = "PROXIMO_A_EXPIRAR";
          else estado = "VIGENTE";
        }

        return {
          ...item,
          nombreCompleto: `${item.nombre || ""} ${item.apellidos || ""}`.trim(),
          nombreCompletoE: `${item.nombre || ""} ${
            item.apellidos || ""
          }`.trim(),
          estadoContrato: estado,
        };
      });
      // Ordenar por nombre en orden alfabético (creciente)
      sortedData.sort((a, b) => {
        const nombreA = (a.nombre || "").toLowerCase();
        const nombreB = (b.nombre || "").toLowerCase();
        return nombreA.localeCompare(nombreB);
      });

      setData(sortedData);
      setDataOriginal(sortedData);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Verificador = (status, fechaVencimiento, graph = false) => {
    const circulo = (status) => {
      switch (status) {
        case "VIGENTE":
          return "green";
        case "EXPIRADO":
          return "red";
        case "PROXIMO_A_EXPIRAR":
          return "orange";
        default:
          return "gray";
      }
    };

    const color = circulo(status);

    const calcularFecha = (fechaVencimiento) => {
      if (!fechaVencimiento || isNaN(new Date(fechaVencimiento).getTime())) {
        return "Sin definir";
      }

      const fecha = new Date(fechaVencimiento);

      // Aseguramos que el día y mes tengan siempre dos dígitos
      const dia = String(fecha.getDate()).padStart(2, "0");
      const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // Mes es 0-indexado, por eso se le suma 1
      const anio = fecha.getFullYear();

      return `${dia}-${mes}-${anio}`; // Devuelve la fecha en formato "DD-MM-YYYY"
    };

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {graph ? (
          <div
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "50%",
              backgroundColor: color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "10px",
            }}
          >
            {calcularFecha(fechaVencimiento)}
          </div>
        ) : (
          <div
            style={{
              width: "70px",
              height: "18px",
              backgroundColor: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#000000",
              fontSize: "10px",
              border: `2px solid ${color}`,
              borderRadius: "14px",
            }}
          >
            <span style={{ paddingTop: "1px" }}>
              {calcularFecha(fechaVencimiento)}
            </span>
          </div>
        )}
      </div>
    );
  };

  const rowIconRef = useRef([]); // Ref único para cada fila
  const showDialog = useConfirmDialog();
  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const [showActions, setShowActions] = useState(false);

  const exportarExcelCompleto = () => {
    showDialog({
      title: "Confirmar contraseña",
      html: `
      <input type="password" id="input-password" class="swal2-input" placeholder="Contraseña de operación" />
    `,
      confirmButtonText: "Confirmar",
      icon: "question",
      onConfirm: () => {
        const contrasena = document.getElementById("input-password").value;
        if (!contrasena) {
          showDialog({
            html: "Por favor ingresa tu contraseña.",
            icon: "warning",
            confirmButtonText: "Intentar de nuevo",
            mostrarCancelar: false,
            onConfirm: exportarExcelCompleto,
          });
          return;
        }

        confirmarDescargarExcel(
          API_URL,
          contrasena,
          showDialog,
          exportarExcelCompleto
        );
      },
    });
  };

  const calcularEstadoContrato = (fechaVencimiento) => {
    if (!fechaVencimiento) return "NO_EXISTENTE";

    const fechaVenc = new Date(fechaVencimiento);
    const fechaActual = new Date();
    const diferenciaDias = Math.floor(
      (fechaVenc - fechaActual) / (1000 * 60 * 60 * 24)
    );

    if (diferenciaDias < 0) return "EXPIRADO";
    if (diferenciaDias <= 60) return "PROXIMO_A_EXPIRAR";
    return "VIGENTE";
  };

  useEffect(() => {
    /*if (filtroSeleccionado === "Contrato") {
      if (estadoContratoFiltro === "Todos") {
        setData(dataOriginal); // Mostrar todos los datos
      } else {
        setData(
          dataOriginal.filter((instalador) => {
            const contrato = instalador.empresa?.contrato;
            const estadoContrato = calcularEstadoContrato(
              contrato?.fechaVencimiento
            );
            return estadoContrato === estadoContratoFiltro; // Filtrar por estado de contrato
          })
        );
      }
    } else {*/
    // Filtrar por el campo seleccionado (INE, IMSS, Cert. Médico, DC3)
    const filteredData = dataOriginal.filter((instalador) => {
      // Reemplazamos "No definido" o "No aplica" con "No existente" en los campos INE, IMSS, CM, y DC3
      const estadoIne =
        instalador.vigIne === "No definido" || instalador.vigIne === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigIne;
      const estadoImss =
        instalador.vigImss === "No definido" ||
        instalador.vigImss === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigImss;
      const estadoCM =
        instalador.vigCM === "No definido" || instalador.vigCM === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigCM;
      const estadoDc3 =
        instalador.vigDc3 === "No definido" || instalador.vigDc3 === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigDc3;

      // Aplicamos los filtros según el campo seleccionado (INE, IMSS, Cert. Médico, DC3)
      if (filtroSeleccionado === "INE") {
        return (
          estadoIne === estadoContratoFiltro || estadoContratoFiltro === "Todos"
        );
      }
      if (filtroSeleccionado === "IMSS") {
        return (
          estadoImss === estadoContratoFiltro ||
          estadoContratoFiltro === "Todos"
        );
      }
      if (filtroSeleccionado === "MEDICAL_CERTIFICATE") {
        return (
          estadoCM === estadoContratoFiltro || estadoContratoFiltro === "Todos"
        );
      }
      if (filtroSeleccionado === "DC3") {
        return (
          estadoDc3 === estadoContratoFiltro || estadoContratoFiltro === "Todos"
        );
      }
      if (filtroSeleccionado === "REPSE") {
        const repse = instalador.empresa?.repse;
        const estadoRepse = calcularEstadoContrato(repse?.fechaVencimiento);
        return (
          estadoRepse === estadoContratoFiltro ||
          estadoContratoFiltro === "Todos"
        );
      }

      return true; // Si no es ninguno de los filtros anteriores, mostrar todo
    });

    setData(filteredData); // Actualizamos los datos filtrados
  }, [estadoContratoFiltro, filtroSeleccionado, dataOriginal]);

  const OpcionesFiltro = (graph = false) => {
    const opcionesFiltro = [
      { value: "Todos", name: "Todos" },
      { value: "VIGENTE", name: "Vigente", icon: graph ? VigenteGra : Vigente },
      {
        value: "EXPIRADO",
        name: "Vencido",
        icon: graph ? ExpiradoGra : Expirado,
      },
      {
        value: "PROXIMO_A_EXPIRAR",
        name: "Próximo a vencer",
        icon: graph ? PorExpirarGra : PorExpirar,
      },
      { value: "NO_EXISTENTE", name: "No existente", icon: graph ? NoGra : No },
    ];

    return opcionesFiltro;
  };

  const handleFilterChange = (selectedOption) => {
    setFiltroSeleccionado(selectedOption); // Actualizamos el filtro seleccionado

    // Si estamos filtrando por "Contrato", restablecer el estado de contrato y mostrar todos los datos
    //  if (selectedOption === "Contrato") {
    //  setData(dataOriginal); // Mostrar todos los datos
    //setEstadoContratoFiltro("Todos"); // Restablecer filtro de estado de contrato
    //} else {
    // Filtramos los datos según el filtro seleccionado y el estado de ese campo
    const filteredData = dataOriginal.filter((instalador) => {
      // Reemplazamos "No definido" o "No aplica" con "No existente" en los campos INE, IMSS, CM, y DC3
      const estadoIne =
        instalador.vigIne === "No definido" || instalador.vigIne === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigIne;
      const estadoImss =
        instalador.vigImss === "No definido" ||
        instalador.vigImss === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigImss;
      const estadoCM =
        instalador.vigCM === "No definido" || instalador.vigCM === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigCM;
      const estadoDc3 =
        instalador.vigDc3 === "No definido" || instalador.vigDc3 === "No aplica"
          ? "NO_EXISTENTE"
          : instalador.vigDc3;

      // Filtrar según el estado de INE
      if (selectedOption === "INE") {
        return (
          estadoIne === estadoContratoFiltro || estadoContratoFiltro === "Todos"
        );
      }

      // Filtrar según el estado de IMSS
      if (selectedOption === "IMSS") {
        return (
          estadoImss === estadoContratoFiltro ||
          estadoContratoFiltro === "Todos"
        );
      }

      // Filtrar según el estado de Certificado Médico
      if (selectedOption === "MEDICAL_CERTIFICATE") {
        return (
          estadoCM === estadoContratoFiltro || estadoContratoFiltro === "Todos"
        );
      }

      // Filtrar según el estado de DC3
      if (selectedOption === "DC3") {
        return (
          estadoDc3 === estadoContratoFiltro || estadoContratoFiltro === "Todos"
        );
      }
      //  if (selectedOption === "REPSE") {
      //  const repse = instalador.empresa?.repse;
      //const estadoRepse = calcularEstadoContrato(repse?.fechaVencimiento);
      //return (
      //estadoRepse === estadoContratoFiltro ||
      //estadoContratoFiltro === "Todos"
      //);
      // }

      return true; // Si no es ninguno de los filtros anteriores, mostrar todo
    });

    // Actualizamos el estado `data` con los datos filtrados
    setData(filteredData);
    //}
  };

  const handleCardClick = (status) => {
    setEstadoContratoFiltro(status);
  };

  const countByStatus = (status) => {
    // Siempre contamos los registros de dataOriginal, no los datos filtrados.
    if (status === "Todos") {
      return dataOriginal.length; // Siempre devuelve el total de registros de dataOriginal
    }

    return dataOriginal.filter((instalador) => {
      if (filtroSeleccionado === "Contrato") {
        const contrato = instalador.empresa?.contrato;
        const estadoContrato = calcularEstadoContrato(
          contrato?.fechaVencimiento
        );
        return estadoContrato === status || status === "Todos";
      }

      // Filtrar por INE
      if (filtroSeleccionado === "INE") {
        const estadoIne =
          instalador.vigIne === "No definido"
            ? "NO_EXISTENTE"
            : instalador.vigIne;
        return estadoIne === status || status === "Todos";
      }

      // Filtrar por IMSS
      if (filtroSeleccionado === "IMSS") {
        const estadoImss =
          instalador.vigImss === "No definido" ||
          instalador.vigImss === "No aplica"
            ? "NO_EXISTENTE"
            : instalador.vigImss;
        return estadoImss === status || status === "Todos";
      }

      // Filtrar por Certificado Médico (vigCM)
      if (filtroSeleccionado === "MEDICAL_CERTIFICATE") {
        const estadoCM =
          instalador.vigCM === "No definido" || instalador.vigCM === "No aplica"
            ? "NO_EXISTENTE"
            : instalador.vigCM;
        return estadoCM === status || status === "Todos";
      }

      // Filtrar por DC3
      if (filtroSeleccionado === "DC3") {
        const estadoDc3 =
          instalador.vigDc3 === "No definido" ||
          instalador.vigDc3 === "No aplica"
            ? "NO_EXISTENTE"
            : instalador.vigDc3;
        return estadoDc3 === status || status === "Todos";
      }
      if (filtroSeleccionado === "REPSE") {
        const repse = instalador.empresa?.repse;
        const estadoRepse = calcularEstadoContrato(repse?.fechaVencimiento);
        return estadoRepse === status || status === "Todos";
      }

      return false; // Si no es ninguno de los filtros anteriores, no devolver nada
    }).length;
  };

  const ordenarPorEstadoVigencia = (rowA, rowB, columnId) => {
    const orden = {
      VIGENTE: 0,
      PROXIMO_A_EXPIRAR: 1,
      EXPIRADO: 2,
      NO_EXISTENTE: 3,
    };

    const valorA = rowA.getValue(columnId);
    const valorB = rowB.getValue(columnId);

    return orden[valorA] - orden[valorB];
  };

  // Tooltip negro reutilizable (mismo estilo que INE)
  const HoverTooltip = ({ title, children, placement = "top" }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    return (
      <span
        onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
        style={{ display: "inline-flex" }}
      >
        {children}

        <Popper
          open={open}
          anchorEl={anchorEl}
          placement={placement}
          style={{ zIndex: 2000 }}
        >
          <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
            <div
              style={{
                background: "#000",
                borderRadius: 6,
                padding: "6px 8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                color: "#fff",
                fontSize: 15,
                whiteSpace: "nowrap",
                margin: "8px",
                fontFamily: "Nunito",
              }}
            >
              {title}
            </div>
          </ClickAwayListener>
        </Popper>
      </span>
    );
  };

  const columns = [
    {
      accessorKey: "nombreCompleto",
      header: "Nombre de Instalador",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      //columnFilterModeOptions: ["fuzzy", "contains", "startsWith", "endsWith"],
      size: 150,
      //filterFn: "includesString",
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const value = cell.getValue();
        const filter = table?.getState().globalFilter;
        return highlightText(capitalize(value), filter);
      },
    },
    {
      accessorKey: "numGafete",
      header: "Numero de credencial",
      //filterFn: "includesString",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
    },
    {
      accessorKey: "empresa.razonSocial",
      header: "Empresa",
      //filterFn: "includesString",
      filterFn: customStringFilter,
      meta: { filterVariant: "texto" },
      size: 160,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ cell, table }) => {
        const valor = cell.getValue();
        const texto = typeof valor === "string" ? valor : "";
        const formateado = formatEmpresa(texto);
        const search = table?.getState().globalFilter;
        return <>{highlightText(formateado, search)}</>;
      },
    },
    /*
    {
      accessorFn: (row) => {
        const fecha = row.empresa?.contrato?.fechaVencimiento;
        if (!fecha) return "NO_EXISTENTE";
        const fechaVenc = new Date(fecha);
        const fechaActual = new Date();
        const dias = Math.floor(
          (fechaVenc - fechaActual) / (1000 * 60 * 60 * 24)
        );
        if (dias < 0) return "EXPIRADO";
        if (dias <= 60) return "PROXIMO_A_EXPIRAR";
        return "VIGENTE";
      },
      header: "Contrato",
      width: 70,
      headerClassName: "center-header",
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => {
        const contrato = row.original.empresa?.contrato;
        let estadoContrato = "No existente";
        const fechaVencimiento = contrato?.fechaVencimiento || "";

        if (contrato?.fechaVencimiento) {
          const fv = new Date(fechaVencimiento);
          const fa = new Date();
          const diff = Math.floor((fv - fa) / (1000 * 60 * 60 * 24));
          estadoContrato =
            diff < 0
              ? "EXPIRADO"
              : diff <= 60
              ? "PROXIMO_A_EXPIRAR"
              : "VIGENTE";
        }

        const title =
          estadoContrato === "VIGENTE"
            ? "Vigente"
            : estadoContrato === "EXPIRADO"
            ? "Vencido"
            : estadoContrato === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        return (
          <HoverTooltip title={title} placement="top">
            <div className="status-circle-page">
              {Verificador(estadoContrato, fechaVencimiento)}
            </div>
          </HoverTooltip>
        );
      },
    },
    {
      accessorFn: (row) => {
        const fecha = row.empresa?.repse?.fechaVencimiento;
        if (!fecha) return "NO_EXISTENTE";
        const dias = Math.floor(
          (new Date(fecha) - new Date()) / (1000 * 60 * 60 * 24)
        );
        if (dias < 0) return "EXPIRADO";
        if (dias <= 60) return "PROXIMO_A_EXPIRAR";
        return "VIGENTE";
      },
      id: "empresa-repse",
      header: "REPSE",
      width: 70,
      headerClassName: "center-header",
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => {
        const repse = row.original.empresa?.repse;
        let estadoContrato = "No existente";
        const fechaVencimiento = repse?.fechaVencimiento || "";

        if (repse?.fechaVencimiento) {
          const fv = new Date(fechaVencimiento);
          const fa = new Date();
          const diff = Math.floor((fv - fa) / (1000 * 60 * 60 * 24));
          estadoContrato =
            diff < 0
              ? "EXPIRADO"
              : diff <= 60
              ? "PROXIMO_A_EXPIRAR"
              : "VIGENTE";
        }

        const title =
          estadoContrato === "VIGENTE"
            ? "Vigente"
            : estadoContrato === "EXPIRADO"
            ? "Vencido"
            : estadoContrato === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        return (
          <HoverTooltip title={title} placement="top">
            <div className="status-circle-page">
              {Verificador(estadoContrato, fechaVencimiento)}
            </div>
          </HoverTooltip>
        );
      },
    },*/
    {
      accessorFn: (row) => {
        const fecha = row?.fechaVencimientoIne;
        if (!fecha) return "NO_EXISTENTE";
        const dias = Math.floor(
          (new Date(fecha) - new Date()) / (1000 * 60 * 60 * 24)
        );
        if (dias < 0) return "EXPIRADO";
        if (dias <= 60) return "PROXIMO_A_EXPIRAR";
        return "VIGENTE";
      },
      id: "ine",
      header: "INE",
      size: 110,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      headerClassName: "center-header",
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => {
        const [anchorEl, setAnchorEl] = useState(null);
        const [open, setOpen] = useState(false);

        const estado = row.original.vigenciaIne?.name || "No existente";
        const fechaVencimiento = row.original?.fechaVencimientoIne;
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        return (
          <div
            onMouseEnter={(e) => {
              setAnchorEl(e.currentTarget);
              setOpen(true);
            }}
            onMouseLeave={() => setOpen(false)}
            style={{ display: "inline-flex" }}
          >
            <div className="status-circle-page">
              {Verificador(estado, fechaVencimiento)}
            </div>

            <Popper
              open={open}
              anchorEl={anchorEl}
              placement="top"
              style={{ zIndex: 2000 }}
            >
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <div
                  style={{
                    background: "#000",
                    border: "1px solid #ccc",
                    borderRadius: 6,
                    padding: "6px 8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    color: "#fff",
                    fontSize: 15,
                    whiteSpace: "nowrap",
                    margin: "8px",
                    fontFamily: "Nunito",
                  }}
                >
                  {title}
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
    {
      accessorFn: (row) => {
        const fecha = row?.fechaVencimientoImss;
        if (!fecha) return "NO_EXISTENTE";
        const dias = Math.floor(
          (new Date(fecha) - new Date()) / (1000 * 60 * 60 * 24)
        );
        if (dias < 0) return "EXPIRADO";
        if (dias <= 60) return "PROXIMO_A_EXPIRAR";
        return "VIGENTE";
      },
      id: "imss",
      header: "IMSS",
      size: 110,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      headerClassName: "center-header",
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => {
        const estado = row.original.vigenciaImss?.name || "No existente";
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        return (
          <HoverTooltip title={title} placement="top">
            <div className="status-circle-page">
              {Verificador(estado, row.original?.fechaVencimientoImss)}
            </div>
          </HoverTooltip>
        );
      },
    },
    {
      accessorFn: (row) => {
        const fecha = row?.fechaVencimientoCertificadoMedico;
        if (!fecha) return "NO_EXISTENTE";
        const dias = Math.floor(
          (new Date(fecha) - new Date()) / (1000 * 60 * 60 * 24)
        );
        if (dias < 0) return "EXPIRADO";
        if (dias <= 60) return "PROXIMO_A_EXPIRAR";
        return "VIGENTE";
      },
      id: "certMedico",
      header: "Cert. Médico",
      size: 110,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      headerClassName: "center-header",
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => {
        const estado =
          row.original.vigenciaCertificadoMedico?.name || "No existente";
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        return (
          <HoverTooltip title={title} placement="top">
            <div className="status-circle-page">
              {Verificador(
                estado,
                row.original?.fechaVencimientoCertificadoMedico
              )}
            </div>
          </HoverTooltip>
        );
      },
    },
    {
      accessorFn: (row) => {
        const fecha = row?.fechaVencimientoDc3;
        if (!fecha) return "NO_EXISTENTE";
        const dias = Math.floor(
          (new Date(fecha) - new Date()) / (1000 * 60 * 60 * 24)
        );
        if (dias < 0) return "EXPIRADO";
        if (dias <= 60) return "PROXIMO_A_EXPIRAR";
        return "VIGENTE";
      },
      id: "dc3",
      header: "DC3",
      size: 110,
      sortingFn: ordenarPorEstadoVigencia,
      filterFn: customStatusFilter,
      meta: { filterVariant: "estado" },
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => {
        const estado = row.original.vigenciaDc3?.name || "No existente";
        const title =
          estado === "VIGENTE"
            ? "Vigente"
            : estado === "EXPIRADO"
            ? "Vencido"
            : estado === "PROXIMO_A_EXPIRAR"
            ? "Próximo a vencer"
            : "No existente";

        return (
          <HoverTooltip title={title} placement="top">
            <div className="status-circle-page">
              {Verificador(estado, row.original.fechaVencimientoDc3)}
            </div>
          </HoverTooltip>
        );
      },
    },
    {
      id: "options",
      header: " ",
      size: 60,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      muiTableBodyCellProps: {
        sx: bodyCellCenterAlign,
      },
      Cell: ({ row }) => {
        return (
          <div style={{ position: "relative" }}>
            <button
              ref={(el) => (rowIconRef.current[row.index] = el)}
              onClick={() => toggleMenuOptions(row.index)}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>
            <Popper
              open={openMenuIndex === row.index}
              anchorEl={rowIconRef.current[row.index]}
              placement="bottom-start"
              style={{ zIndex: 1302 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    position: "static",
                    top: "30px",
                    right: "0",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    padding: "10px",
                    minWidth: "200px",
                    zIndex: 1302,
                  }}
                >
                  <p onClick={() => documentosInstalador(data[row.index]?.id)}>
                    <img src={Documento} alt="" /> Documentación
                  </p>
                  <p onClick={() => editarInstalador(data[row.index]?.id)}>
                    <img src={Editar} alt="" /> Editar Instalador
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const options = {
    enableColumnFilters: false,
    enableSorting: true,
    enablePagination: true,
    initialState: {
      pagination: {
        pageSize: 5, // Cambia el número de filas por página a 10
        pageIndex: 0,
      },
    },
  };

  const opcionesFiltro = [
    //{ value: "Contrato", name: "Contrato" },
    { value: "INE", name: "INE" },
    { value: "IMSS", name: "IMSS" },
    { value: "MEDICAL_CERTIFICATE", name: "Cert. Médico" },
    { value: "DC3", name: "DC3" },
    // { value: "REPSE", name: "REPSE" },
  ];

  const pdfRef = useRef();

  const datosFiltrados =
    tableInstance?.getFilteredRowModel().rows.map((row) => row.original) || [];

  return (
    <div className="idc-container" style={{ display: "flex", height: "100%" }}>
      <div className="idc-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>

      <div
        className="idc-main"
        style={{ flex: 1, padding: "10px", width: "80%" }}
      >
        {/* Filtro superior (Contrato / INE / IMSS / etc.) */}
        <div className="idc-topFilter">
          <CustomSelect
            options={opcionesFiltro}
            value={filtroSeleccionado}
            onChange={(e) => handleFilterChange(e.target.value)}
            fontWeight={"700"}
            color={"#223D51"}
            heightOption={"auto"}
            topOption={"0px"}
            width={"240px"}
            fontSize={"12px"}
          />
        </div>

        {/* Cards de conteo/estado */}
        <div className="idc-cardsWrap">
          <div
            className="idc-cardsRow"
            style={{ display: "flex", gap: "20px", marginBottom: "10px" }}
          >
            {OpcionesFiltro(true).map((opcion) => {
              const isTodos = opcion.value === "Todos";
              const progressValue = calculateProgress(opcion.value);

              return (
                <Card
                  style={{
                    boxShadow:
                      estadoContratoFiltro === opcion.value
                        ? "0 5px 15px rgba(0, 0, 0, 0.35)"
                        : "none",
                  }}
                  key={opcion.value}
                  status={opcion.name}
                  count={countByStatus(opcion.value)}
                  onClick={() => handleCardClick(opcion.value)}
                  icon={isTodos ? opcion.icon : null}
                  progress={isTodos ? undefined : progressValue}
                  color={
                    opcion.value === "VIGENTE"
                      ? "#62C776"
                      : opcion.value === "EXPIRADO"
                      ? "#EC3E49"
                      : opcion.value === "PROXIMO_A_EXPIRAR"
                      ? "#FEBC61"
                      : opcion.value === "NO_EXISTENTE"
                      ? "#878787"
                      : "#CCCCCC"
                  }
                />
              );
            })}
          </div>
        </div>

        {/* Título + select de estado + Exportar */}
        <div
          className="idc-controls"
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            position: "relative",
            zIndex: 2,
          }}
        >
          <h3
            className="idc-title"
            style={{
              color: "#223D51",
              fontWeight: "700",
              fontSize: "18px",
              margin: 0,
            }}
          >
            Documentos instaladores
          </h3>

          <div className="idc-statusSelect">
            <CustomSelect
              options={OpcionesFiltro(false)}
              value={estadoContratoFiltro}
              onChange={(e) => setEstadoContratoFiltro(e.target.value)}
              placeholderCustom={`Estado del ${
                filtroSeleccionado === "MEDICAL_CERTIFICATE"
                  ? "cert. médico"
                  : filtroSeleccionado /*=== "Contrato"
                  ? "contrato"
                  : filtroSeleccionado*/
              }:`}
              fontWeight={"700"}
              color={"#223D51"}
              heightOption={"140px"}
              topOption={"0px"}
              width={"240px"}
              fontSize={"12px"}
              height={"30px"}
              paddingTop={"5px"}
              overflow={"visible"}
              marginLeft={"10px"}
            />
          </div>

          {/* ⬇️ ENVUELTO EN ClickAwayListener PARA CERRAR AL HACER CLICK FUERA */}
          <ClickAwayListener onClickAway={() => setShowActions(false)}>
            <div
              className="idc-export"
              style={{ position: "relative", display: "inline-block" }}
            >
              <PDFInstallers
                data={datosFiltrados}
                ref={pdfRef}
                style={{ display: "none" }}
                className="pdf-export-btn"
              />

              <CustomButton
                background={"#223D51"}
                width={"94px"}
                height={"31px"}
                fontSize={"12px"}
                color={"#FFFFFF"}
                text={"Exportar"}
                fontWeight={700}
                fontStyle={"normal"}
                border={"0.5px solid #C3C3C3"}
                icon
                src={DescargarG}
                iconW={"12px"}
                iconM={"5px"}
                onClick={() => setShowActions(!showActions)}
              />

              {showActions && (
                <div
                  className="box-action"
                  style={{
                    position: "absolute",
                    top: "calc(100% - 15px)",
                    left: 0,
                    zIndex: 1302,
                    background: "#fff",
                    border: "1px solid #C3C3C3",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    padding: "8px",
                    minWidth: "200px",
                  }}
                >
                  <p
                    onClick={() => exportarExcelInstaladores(datosFiltrados)}
                    className="box-button-action"
                  >
                    Formato Excel
                  </p>
                  <p
                    onClick={() => {
                      setShowActions(false);
                      pdfRef.current?.generarPDF(datosFiltrados);
                    }}
                    className="box-button-action"
                  >
                    Formato PDF
                  </p>
                  <p
                    onClick={() => exportarExcelCompleto()}
                    className="box-button-action"
                  >
                    Excel Completo
                  </p>
                </div>
              )}
            </div>
          </ClickAwayListener>
        </div>

        {/* Tabla (scrollable en móvil) */}
        <div className="idc-tableWrap">
          <TablaMRT
            columns={columns}
            data={data}
            options={options}
            onTableReady={(table) => setTableInstance(table)}
          />
        </div>
      </div>
    </div>
  );
};

export default InstallersDocumentsPage;
